import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../src/components/Widget/ThemeContext';

function Send({ ready }) {
  const { mainColor } = useContext(ThemeContext);

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        className={ready ? 'rw-send-icon-ready' : 'rw-send-icon'}
        style={{ fill: ready && mainColor }}
        d="M20.8648 10.8751L4.82983 3.30006C4.37483 3.08506 3.85983 3.15506 3.47983 3.48006C3.09983 3.80506 2.95483 4.30506 3.09483 4.78506L5.01483 11.2551H11.4948V12.7501H5.01983L3.09983 19.2151C2.95983 19.6951 3.10483 20.1951 3.48483 20.5201C3.71983 20.7201 4.00483 20.8251 4.29483 20.8251C4.47483 20.8251 4.65983 20.7851 4.83483 20.7051L20.8648 13.1401C21.3048 12.9301 21.5798 12.4951 21.5798 12.0101C21.5798 11.5201 21.3048 11.0901 20.8648 10.8801V10.8751Z"
        fill="#202023"
      />
    </svg>
  );
}


Send.propTypes = {
  ready: PropTypes.bool
};

export default Send;
